import { STM_COUNTRY_CONFIG } from '../constants/constants'
import { useCountryCode } from './use-country-code'

export const useStmMallCode = (): string | null => {
  const countryCode = useCountryCode()
  return STM_COUNTRY_CONFIG[countryCode]?.mallCode ?? null
}
